<template>
  <Dashboard title="Statistics">
    <div
      id="statistics"
      v-if="selectedApplicationId"
    >
      <div class="row-small">
        <Loading 
          v-if="isLoading"
          full="true"
        />

        <div class="col-8 col-12-md col-24-sm">
          <WeekGraph
            title="Active users"
            :week="data.activeUsersLastWeek"
            :lastMonth="`Active users last month: ${data.activeUsersLastMonth}`"
            :thisMonth="`Active users this month: ${data.activeUsersThisMonth}`"
          />
        </div>

        <div class="col-8 col-12-md col-24-sm">
          <WeekGraph
            title="Diaries"
            :week="data.diariesLastWeek"
            :lastMonth="`Diaries last month: ${data.diariesLastMonth}`"
            :thisMonth="`Diaries this month: ${data.diariesThisMonth}`"
          />
        </div>

        <div class="col-8 col-12-md col-24-sm">
          <WeekGraph
            title="Push notifications"
            :week="data.pushnotificationsLastWeek"
            :lastMonth="`Push notifications last month: ${data.pushnotificationsLastMonth}`"
            :thisMonth="`Push notifications this month: ${data.pushnotificationsThisMonth}`"
          />
        </div>

        <div class="col-8 col-12-md col-24-sm">
          <WeekGraph
            title="Registrations"
            :week="data.registrationsLastWeek"
            :lastMonth="`Registrations last month: ${data.registrationsLastMonth}`"
            :thisMonth="`Registrations this month: ${data.registrationsThisMonth}`"
            :total="`Total registrations: ${data.totalRegistrations}`"
          />
        </div>
      </div>
    </div>

    <NoApplicationSelected v-else/>
  </Dashboard>  
</template>

<script>
  import { API } from '../../services/api.ts'
  import Dashboard from '../../components/dashboard/dashboard.vue'
  import NoApplicationSelected from '../../components/error/noApplicationSelected.vue'
  import WeekGraph from '../../components/graph/weekGraph/weekGraph.vue'
  import Loading from '../../components/loading/loading.vue'

  export default {
    name: 'Statistics',
    components: {
      Dashboard,
      NoApplicationSelected,
      WeekGraph,
      Loading
    },
    data() {
      return{
        selectedApplicationId: localStorage.selectedApplicationId,
        isLoading: true,
        data: {
          "activeUsersLastWeek":{"day2":0,"day6":0,"day1":0,"day7":0,"day4":0,"day3":0,"day5":0},
          "diariesLastMonth": 0,
          "pushnotificationsLastMonth":0,
          "registrationsThisMonth": 0,
          "totalRegistrations": 0,
          "pushnotificationsLastWeek":{"day2":0,"day6":0,"day1":0,"day7":0,"day4":0,"day3":0,"day5":0},
          "diariesLastWeek":{"day2":0,"day6":0,"day1":0,"day7":0,"day4":0,"day3":0,"day5":0},
          "pushnotificationsThisMonth": 0,
          "activeUsersLastMonth": 0,
          "registrationsLastMonth": 0,
          "activeUsersThisMonth": 0,
          "registrationsLastWeek":{"day2":0,"day6":0,"day1":0,"day7":0,"day4":0,"day3":0,"day5":0},
          "diariesThisMonth": 0
        }
      }
    },
    mounted() {
      const self = this;
      
      API.get(
        `index.cfm?act=statistics.summary`
      ).then(
        response => {
          console.log(response);
          this.isLoading = false;
          this.data = response.data.data;
        }
      ).catch(function (error) {
        if (error.response.status === 403) {
          localStorage.removeItem('selectedApplicationName');
          localStorage.removeItem('selectedApplicationId');        
          self.selectedApplicationId = null
        }
      });
    }
  }
</script>

<style lang="scss">
  #statistics {
    
    .week-graph {
      margin-bottom: 15px;
    }
  }  
</style>
